import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-active"]

import { onMounted, onUnmounted, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

interface EMITS {
  (e: 'files-dropped', val: File[])
  (e: 'items-dropped', val: DataTransferItem[])
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InputFileDropBase',
  props: {
  disabled: { type: Boolean, default: false },
  overlayBackgroundColor: {
    type: String,
    default: 'rgba(255, 255, 255, 0.8)'
  }
},
  emits: ["files-dropped", "items-dropped"],
  setup(__props, { emit: __emit }) {

const props = __props
const { disabled } = toRefs(props)
const emits = __emit
const { t } = useI18n()
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
const active = ref(false)
let inActiveTimeout: any = null

function onDrop(event: DragEvent) {
  if (disabled.value) return
  const files = (event as DragEvent).dataTransfer?.files
  if (!files?.length) return
  setInactive()
  if (event.dataTransfer?.items) {
    emits('items-dropped', event.dataTransfer?.items ? [...event.dataTransfer.items] : [])
  } else if (event.dataTransfer?.files) {
    emits('files-dropped', event.dataTransfer?.files ? [...event.dataTransfer.files] : [])
  }
}

function preventDefaults(event) {
  event.preventDefault()
}
function setActive(event: DragEvent) {
  const dt = event.dataTransfer
  if (
    dt &&
    dt.types &&
    (dt.types.indexOf ? dt.types.indexOf('Files') != -1 : dt.types.includes('Files'))
  ) {
    active.value = true
    clearTimeout(inActiveTimeout)
  }
}
function setInactive() {
  inActiveTimeout = setTimeout(() => {
    active.value = false
  }, 50)
}

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
})

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'input-file-drop-box',
      {
        'input-file-drop-box--active': active.value && !_unref(disabled),
        'input-file-drop-box--disabled': active.value && _unref(disabled)
      }
    ]),
    "data-active": active.value,
    onDragenter: _withModifiers(setActive, ["prevent"]),
    onDragover: _withModifiers(setActive, ["prevent"]),
    onDragleave: _withModifiers(setInactive, ["prevent"]),
    onDrop: _withModifiers(onDrop, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "content"),
    (active.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "input-file-drop-box--overlay",
          style: _normalizeStyle({ backgroundColor: __props.overlayBackgroundColor })
        }, [
          (!_unref(disabled))
            ? _renderSlot(_ctx.$slots, "active", { key: 0 }, () => [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('general__data__file-drop')), 1)
              ])
            : _renderSlot(_ctx.$slots, "disabled", { key: 1 })
        ], 4))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})